export type SortDirection = 'asc' | 'desc';

export const getSortableValue = (value: unknown): string | number => {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'number') {
    return value;
  }

  if (typeof value === 'boolean') {
    return value ? 1 : 0;
  }

  const normalized = String(value).trim();
  return normalized.toLowerCase();
};

export const compareValues = (left: unknown, right: unknown, direction: SortDirection) => {
  const leftValue = getSortableValue(left);
  const rightValue = getSortableValue(right);

  if (typeof leftValue === 'number' && typeof rightValue === 'number') {
    return direction === 'asc' ? leftValue - rightValue : rightValue - leftValue;
  }

  const comparison = String(leftValue).localeCompare(String(rightValue), undefined, { sensitivity: 'base' });
  return direction === 'asc' ? comparison : -comparison;
};

export const sortRows = <T, K extends keyof T>(rows: T[], direction: SortDirection, accessor: (row: T) => K | unknown) => {
  return [...rows].sort((left, right) => compareValues(accessor(left), accessor(right), direction));
};

export const getSortIndicator = (activeKey: string, currentKey: string, direction: SortDirection) => {
  if (activeKey !== currentKey) {
    return '⇅';
  }
  return direction === 'asc' ? '↑' : '↓';
};
